<div class="flex-auto border-t -mt-px pt-4 sm:pt-6">
    <div class="w-full max-w-screen-xl mx-auto">

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
            <div
                class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                <div class="flex flex-col sm:flex-row items-start justify-between">
                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Observaciones
                    </div>
                    <button mat-flat-button color="accent" (click)="newObservation(null);"><mat-icon svgIcon="heroicons_solid:plus"></mat-icon> Nueva Observación</button>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
                    <div class="row">

                        <div class="col-12">
                            <app-grid-component
                                *ngIf="verGrid"
                                [datos]="objetoGridConfiguration.Data"
                                [columns]="objetoGridConfiguration.Columns"
                                [exportExcel]="objetoGridConfiguration.ExportExcel"
                                [columnHiding]="objetoGridConfiguration.ColumnHiding"
                                [Checkbox]="objetoGridConfiguration.Checkbox"
                                [Editing]="objetoGridConfiguration.Editing"
                                [Columnchooser]="objetoGridConfiguration.Columnchooser"
                                [searchPanel]="objetoGridConfiguration.SearchPanel"
                                [scroll]="objetoGridConfiguration.Scroll"
                                (messageEvent)="receiveMessage($event)"
                                (datosevent)="datosMessage($event)"
                                [toolbar]="objetoGridConfiguration.ToolBox"
                                (onRowUpdated)="Actualizar($event)"
                                (modificar)='modificar($event.modificar.key)'
                                (eliminar)='eliminar($event.eliminar.key)'
                                [descargarExcel]="descargarExcel" 
                                [nombreReporte]="nombreReporte"
                            ></app-grid-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>